// vendor
require('@babel/polyfill');
require('expose?URLSearchParams!url-search-params');
require('expose?angular!angular');
require('./third-party/angular-sanitize/angular-sanitize.js');
require('./third-party/angular-animate/angular-animate.js');
require('./third-party/angular-cookies/angular-cookies.js');
require('./third-party/angular-ui-router/release/angular-ui-router.js');
require('./third-party/checklist-model/checklist-model.js');
require('./third-party/kareo-ui-tour/kareo-ui-tour.js');
require('expose?moment!moment');
require('./third-party/moment-timezone/builds/moment-timezone-with-data.js');
require('expose?Pikaday!pikaday');
require('./third-party/pikaday-angular/pikaday-angular.js');
require('./third-party/ksc-ng/dist/ksc.js');
require('expose?Flow!./third-party/ng-flow/dist/ng-flow-standalone.js');
require('./third-party/angular-utils-pagination/dirPagination.js');
require('./third-party/angular-modal-service/dst/angular-modal-service.js');
require('./third-party/angucomplete-alt/angucomplete-alt.js');
require('expose?angularDragula!angular-dragula');
require('./third-party/angular-ui-mask/dist/mask.js');
require('@kareo-engineering/ng-tags-input');